/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreate } from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreate';
import {
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreateFromJSON,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreateFromJSONTyped,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreateToJSON,
} from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreate';
import type { SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate } from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate';
import {
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSON,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSONTyped,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateToJSON,
} from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate';
import type { SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate } from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate';
import {
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateFromJSON,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateFromJSONTyped,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateToJSON,
} from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate';
import type { SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreate } from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreate';
import {
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreateFromJSON,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreateFromJSONTyped,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreateToJSON,
} from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreate';
import type { SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate } from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate';
import {
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateFromJSON,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateFromJSONTyped,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateToJSON,
} from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate';
import type { SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate } from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate';
import {
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateFromJSON,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateFromJSONTyped,
  SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateToJSON,
} from './SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate';

/**
 * @type SingleTurnChatInferencerCreatePolymorphic
 *
 * @export
 */
export type SingleTurnChatInferencerCreatePolymorphic =
  | ({ protocol: 'AINO' } & SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreate)
  | ({
      protocol: 'AZURE_OPEN_AI_ASSISTANT';
    } & SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate)
  | ({ protocol: 'CUSTOM_API' } & SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreate)
  | ({
      protocol: 'OPEN_AI_ASSISTANT';
    } & SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreate)
  | ({ protocol: 'POE' } & SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate)
  | ({ protocol: 'SPITCH' } & SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreate);

export function SingleTurnChatInferencerCreatePolymorphicFromJSON(
  json: any,
): SingleTurnChatInferencerCreatePolymorphic {
  return SingleTurnChatInferencerCreatePolymorphicFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCreatePolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCreatePolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'AINO':
      return Object.assign(
        {},
        SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreateFromJSONTyped(json, true),
        { protocol: 'AINO' } as const,
      );
    case 'AZURE_OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSONTyped(
          json,
          true,
        ),
        { protocol: 'AZURE_OPEN_AI_ASSISTANT' } as const,
      );
    case 'CUSTOM_API':
      return Object.assign(
        {},
        SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateFromJSONTyped(json, true),
        { protocol: 'CUSTOM_API' } as const,
      );
    case 'OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreateFromJSONTyped(json, true),
        { protocol: 'OPEN_AI_ASSISTANT' } as const,
      );
    case 'POE':
      return Object.assign(
        {},
        SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateFromJSONTyped(json, true),
        { protocol: 'POE' } as const,
      );
    case 'SPITCH':
      return Object.assign(
        {},
        SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateFromJSONTyped(json, true),
        { protocol: 'SPITCH' } as const,
      );
    default:
      throw new Error(
        `No variant of SingleTurnChatInferencerCreatePolymorphic exists with 'protocol=${json['protocol']}'`,
      );
  }
}

export function SingleTurnChatInferencerCreatePolymorphicToJSON(
  value?: SingleTurnChatInferencerCreatePolymorphic | null,
): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'AINO':
      return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAinoCreateToJSON(value);
    case 'AZURE_OPEN_AI_ASSISTANT':
      return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateToJSON(value);
    case 'CUSTOM_API':
      return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerCustomApiCreateToJSON(value);
    case 'OPEN_AI_ASSISTANT':
      return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerOpenAiAssistantCreateToJSON(value);
    case 'POE':
      return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateToJSON(value);
    case 'SPITCH':
      return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerSpitchCreateToJSON(value);
    default:
      throw new Error(
        `No variant of SingleTurnChatInferencerCreatePolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
